import { type BetterNavigateOptions } from './Tools';

type History = {
    pathname: BetterNavigateOptions['pathname'];
    replace: BetterNavigateOptions['replace'];
    state: BetterNavigateOptions['state'];
}[];

export const history: History = [];

export function getHistory() {
    return history;
}

export function pushHistory(locObj: BetterNavigateOptions) {
    history.push({ pathname: locObj.pathname, replace: locObj.replace, state: locObj.state });
    if (history.length > 5) {
        history.shift();
    }
}
